import { combineReducers } from 'redux'

import { brandProfile } from './brand'
import { dashboardSetupProfile } from './dashboardSetup'

export const dashboardReducer = combineReducers({
  brandProfile,
  dashboardSetupProfile
})
